import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import { saveClockItem, clocksSummary } from '../../../store/actions';
import iconRight from '../../../assets/images/Icon-arrow-right.png';
import Select from 'react-select';

export const ClockItem = (props) => {

  const [BIClocks, setBIClocks] = useState([]);
  const [itemName, setItemName] = useState("");
  const [itemDescription, setDescription] = useState("");
  const [unitPrice, setPrice] = useState(0);
  const [linkedBillingItems, setLinkedBI] = useState([]);

  useEffect(() => {
    setBIClocks(props.CLOCKS_BILLING_ITEMS
      .map(bi => ({ ...bi, label: bi.serviceName, value: bi._id }))
    );
    if (props.isEdit) {
      let { itemName, itemDescription, linkedBillingClocks } = props.clockDetails;
      setItemName(itemName);
      setDescription(itemDescription);
      let linked = props.CLOCKS_BILLING_ITEMS
        .filter(bi => linkedBillingClocks?.includes(bi?._id));
      setLinkedBI(linked.map(bi => ({ ...bi, label: bi.serviceName, value: bi._id })));
    }
  }, [props.CLOCKS_BILLING_ITEMS, props.clockDetails]);

  async function addClockItem() {
    let payload = { itemName, itemDescription, linkedBillingItems: linkedBillingItems.map(lbi => lbi._id), unitPrice }
    if (props.clockDetails && props.clockDetails._id) {
      payload._id = props.clockDetails._id
    };
    await props.saveClockItem(payload);
    await props.clocksSummary();

    props.closeSidebar();
  }

  return (
    <div className={`AddPurchaseOrders`} >
      <div className="overlay-pop" onClick={props.closeSidebar}></div>
      <div className="userHeader d-flex align-items-center justify-content-between">
        <div className="UserName">
          <h2> {props.isEdit ? `Edit Clock Item` : "Add Clock Item"} </h2>
        </div>
        <div className="action-button d-flex align-items-center justify-content-between">
          <div className="iconRight" onClick={props.closeSidebar}>
            <img src={iconRight} alt=""></img>
          </div>
        </div>
      </div>
      <div className="item-body">

        <div className="itemList d-flex align-items-center justify-content-between">
          <div className="itemLabel">
            <span>Item Name</span>
          </div>
          <div className="itemOutput text-end">
            <input
              type={"text"}
              value={itemName}
              onChange={e => setItemName(e.target.value)}
            />
          </div>
        </div>
        <div className="itemList d-flex align-items-center justify-content-between">
          <div className="itemLabel">
            <span>Description</span>
          </div>
          <div className="itemOutput text-end">
            <input
              type="text"
              value={itemDescription}
              onChange={e => setDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="itemList d-flex align-items-center justify-content-between">
          <div className="itemLabel">
            <span>Unit Price</span>
          </div>
          <div className="itemOutput text-end">
            <input
              type="number"
              value={unitPrice}
              onChange={e => setPrice(e.target.valueAsNumber)}
            />
          </div>
        </div>
        <div className="itemList d-flex align-items-center justify-content-between">
          <div className="itemLabel">
            <span>Linked Billing Items</span>
          </div>
          <div className="itemOutput text-start">
            <Select
              options={BIClocks}
              value={linkedBillingItems}
              placeholder={"Please Select Clock Type"}
              onChange={setLinkedBI}
              isMulti={true}
            />
          </div>
        </div>
      </div>
      <div className="item-footer d-flex align-items-right justify-content-end">
        <button className="pop_wth_btn" onClick={props.closeSidebar}>Cancel</button>
        <button className="save-btn" onClick={addClockItem} disabled={!itemName}>Save</button>
      </div>
    </div>
  )
}


const mapStateToProps = ({ InventoryItemsReducer }) => {
  let { CLOCKS_BILLING_ITEMS, CLOCKS_SUMMARY } = InventoryItemsReducer;
  return { CLOCKS_BILLING_ITEMS, CLOCKS_SUMMARY };
};
export default connect(mapStateToProps, { saveClockItem, clocksSummary })(ClockItem);
